import { Box } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const PipelineMessage = ({ pipeline = [], handleAddPipeline, paddingX = 0 }) => {
  // Group steps by x_level
  const groupedByLevel = pipeline?.reduce((acc, step) => {
    const level = step.x_level;
    if (!acc[level]) acc[level] = [];
    acc[level].push(step);
    return acc;
  }, {});

  const levels = Object.keys(groupedByLevel).sort((a, b) => Number(a) - Number(b));

  return (
    <Box
      className="pipeline-scroll"
      sx={{
        width: '100%',
        overflowX: 'auto',
        display: 'flex',
        justifyContent: 'flex-start',
        mt: 2,
        px: paddingX,
        my: 2,
      }}
    >
      <Box
        className="pipeline-container"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          cursor: 'pointer',
          '&:hover .pipeline-block': {
            borderColor: '#666',
          },
          '&:hover .pipeline-arrow': {
            color: '#666',
          },
        }}
        onClick={() => {
          handleAddPipeline(pipeline);
        }}
      >
        {levels.map((level, levelIndex) => (
          <Box
            key={level}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              position: 'relative',
            }}
          >
            {groupedByLevel[level].map((step) => (
              <Box
                key={step.currentNode.nodeId}
                className="pipeline-block"
                sx={{
                  width: '75px',
                  height: '75px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#fff',
                  border: '2px dashed #ccc',
                  borderRadius: '5px',
                  fontWeight: 'bold',
                  fontSize: 'small',
                  padding: '8px',
                  color: '#333',
                  textAlign: 'center',
                  wordBreak: 'break-word',
                  transition: 'border-color 0.3s',
                }}
              >
                {step.currentNode.nodeName}
              </Box>
            ))}

            {levelIndex < levels.length - 1 && (
              <ArrowForwardIcon
                className="pipeline-arrow"
                sx={{
                  position: 'absolute',
                  right: -28,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#aaa',
                }}
              />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PipelineMessage;
